<template>
  <BaseElForm v-bind="$attrs" ref="curFormRef">
    <component
      :is="item.component"
      v-for="item in computedFields"
      :key="item.prop"
      v-bind="item.props"
      v-on="item.on"
    >
      <div class="inline-flex flex-col w-full">
        <!-- 使用增強的遞迴渲染器 -->
        <BobFormRenderer
          v-if="item.body"
          :config="enhanceConfigWithBinding(item.body, item.prop)"
        />
      </div>
    </component>
  </BaseElForm>
</template>

<script>
import { map } from 'lodash'
import { computed, defineComponent, inject, nextTick, onMounted, ref } from 'vue'
import BaseElFormItem from './BaseElFormItem.vue'
import BobFormRenderer from './BobFormRenderer.vue'
import { useVModel } from '@vueuse/core'

export default defineComponent({
  name: 'BobForm',
  components: {
    BobFormRenderer,
  },
  props: {
    formRef: {
      type: Object,
      default: null,
    },
    fields: {
      type: Array,
      default: () => [],
    },
  },
  setup (props, { emit }) {
    const curFormRef = ref(null)
    const syncFormRef = useVModel(props, 'formRef', emit)
    const formData = inject('formData')

    // 更新表單值的函式
    const updateFormValue = (prop, value) => {
      if (formData && prop) {
        formData[prop] = value
      }
    }

    // 遞迴增強 config，注入資料綁定邏輯
    const enhanceConfigWithBinding = (config, formProp) => {
      if (!config) return config

      const enhancedConfig = { ...config }

      // 如果是頂層且有 formProp，注入 v-model 綁定
      if (formProp && formData) {
        enhancedConfig.props = {
          ...config.props,
          value: formData[formProp],
        }

        enhancedConfig.on = {
          ...config.on,
          input: (value) => {
            updateFormValue(formProp, value)
            // 如果原本有 input 事件處理器，也要呼叫
            if (config.on && config.on.input) {
              config.on.input(value)
            }
          },
        }
      }

      // 遞迴處理 slots
      if (config.slots) {
        enhancedConfig.slots = {}
        Object.entries(config.slots).forEach(([slotName, slot]) => {
          if (Array.isArray(slot)) {
            enhancedConfig.slots[slotName] = slot.map(child =>
              enhanceConfigWithBinding(child, child.prop),
            )
          } else if (slot && typeof slot === 'object') {
            enhancedConfig.slots[slotName] = enhanceConfigWithBinding(slot, slot.prop)
          } else {
            enhancedConfig.slots[slotName] = slot
          }
        })
      }

      // 遞迴處理 childs
      if (config.childs) {
        enhancedConfig.childs = config.childs.map(child =>
          enhanceConfigWithBinding(child, child.prop),
        )
      }

      return enhancedConfig
    }

    const computedFields = computed(() => {
      return map(props.fields, (item) => {
        if (!item.component) {
          item.component = BaseElFormItem
        }

        if (!item.body) {
          item.body = {
            component: 'div',
            render: () => '',
            slots: {},
          }
        }

        return {
          ...item,
          props: {
            label: item.label,
            prop: item.prop,
            ...item.props,
          },
        }
      })
    })

    onMounted(async () => {
      await nextTick()
      if (syncFormRef) {
        syncFormRef.value = curFormRef.value
      }
    })

    return {
      computedFields,
      formData,
      curFormRef,
      updateFormValue,
      enhanceConfigWithBinding,
    }
  },
})
</script>

<style lang="postcss" scoped>
</style>
